// extracted by mini-css-extract-plugin
module.exports = {"blockWrappper":"demo-crm-module--blockWrappper--2UFRE","videoResponsive":"demo-crm-module--videoResponsive--3N0Nf"};